import { render, staticRenderFns } from "./StatsList.vue?vue&type=template&id=3f6ad1a3&scoped=true"
import script from "./StatsList.vue?vue&type=script&lang=js"
export * from "./StatsList.vue?vue&type=script&lang=js"
import style0 from "./StatsList.vue?vue&type=style&index=0&id=3f6ad1a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6ad1a3",
  null
  
)

export default component.exports